import { fetchOffline, isRunningInElectron } from '@/utils/electronUtils.js'
import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { sendMessage } from '@/utils/dtq'
const offline = fetchOffline()
NProgress.configure({ showSpinner: false }) // NProgress Configuration
import store from './store'

const whiteList = ['/login', '/silent-login', '/suspension'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // 面包屑导航数据处理
  const obj = {}
  const { name, meta } = from
  obj.routerName = name
  obj.query = from.query
  obj.toName = to.name
  obj.name = from.query.name || from.params.name || meta?.title
  store.commit('router/SET_ROUTER_LIST', obj)

  console.log('路由栈 - prev路由', from.path, from)
  console.log('路由栈 - current路由', to.path, to)

  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()
  if (offline) {
    next()
  } else if (hasToken) {
    if (to.path === '/login') {
      if (isRunningInElectron()) {
        // 运行在electron 中，默认加载页即 login 登录页
        next()
      } else {
        // if is logged in, redirect to the home page -- 如果已登录，则重定向到主页
        next({ path: '/' })
        NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
      }
    } else {
      next()
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach((to, from) => {
  if (isRunningInElectron()) {
    // 页面切换后清空所有答题器的回显
    sendMessage({ fun: 'dtq_echo_set', uID: 0, msg: '' })
  }
  // finish progress bar
  NProgress.done()
})
